module.exports = __webpack_public_path__ + "img/ac9d4af.png";